import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info?.componentStack);
    try {
      const payload = {
        message: error?.message || String(error),
        stack: (error?.stack || '').split('\n').slice(0, 6).join('\n'),
        componentStack: (info?.componentStack || '').split('\n').slice(0, 8).join('\n'),
        url: typeof window !== 'undefined' ? window.location.href : '',
        at: new Date().toISOString(),
      };
      this.setState({ details: payload });
      // Salva TUTTI gli errori recenti (ultimi 5) in localStorage per diagnosi
      try {
        const hist = JSON.parse(localStorage.getItem('rubbi_errors_history') || '[]');
        hist.unshift(payload);
        localStorage.setItem('rubbi_errors_history', JSON.stringify(hist.slice(0, 5)));
      } catch { /* noop */ }
      localStorage.setItem('rubbi_last_error', JSON.stringify(payload));
    } catch { /* noop */ }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, details: null });
  };

  render() {
    if (this.state.hasError) {
      const d = this.state.details;
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          padding: '60px 20px', textAlign: 'center', minHeight: '300px'
        }}>
          <AlertTriangle size={40} color="#f59e0b" style={{ marginBottom: 16 }} />
          <h3 style={{ color: '#fff', fontSize: 16, fontWeight: 600, marginBottom: 8 }}>
            Si è verificato un errore
          </h3>
          <p style={{ color: '#888', fontSize: 13, marginBottom: 20, maxWidth: 400 }}>
            La sezione ha riscontrato un problema. Prova a ricaricare.
          </p>
          {d && (
            <details style={{ color: '#888', fontSize: 11, marginBottom: 16, maxWidth: 600, width: '100%', textAlign: 'left' }} data-testid="error-boundary-details">
              <summary style={{ cursor: 'pointer', color: '#aaa' }}>Dettagli tecnici</summary>
              <pre style={{ background: '#111', padding: 10, borderRadius: 6, overflow: 'auto', fontSize: 11, color: '#f59e0b', marginTop: 8 }}>
{d.message}{'\n\n'}{d.stack}{'\n\nComponent stack:'}{'\n'}{d.componentStack}
              </pre>
            </details>
          )}
          <button
            onClick={this.handleReset}
            data-testid="error-boundary-retry"
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: '8px 20px', borderRadius: 8,
              background: '#1a1a2e', border: '1px solid #333',
              color: '#fff', fontSize: 13, cursor: 'pointer'
            }}
          >
            <RefreshCw size={14} />
            Riprova
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
